import type { QueryClient } from "@tanstack/react-query";

let portalQueryClient: QueryClient | null = null;

export const setPortalQueryClient = (client: QueryClient) => {
  portalQueryClient = client;
};

export const invalidateMetabaseQueriesAfterTokenRefresh = () => {
  void portalQueryClient?.invalidateQueries({ queryKey: ["metabase"] });
};
